import React, {Component} from 'react';
import PropTypes from 'prop-types';

import { Select } from '@mui/material';

class Dropdown extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.value || ''
		};
	}
	handleChange(event) {
		this.setState({ value: event.target.value })
	}

	render() {
		const fieldName = this.props.name
		const noOption = this.props['data-notrequired'] ? <option key={`${fieldName}_noop`} value=''></option> : ''

		return (
			<div>
				<Select
					variant="standard"
					native
					id={this.props.id}
					name={fieldName}
					defaultValue={this.state.value}
					onChange={ this.props.onChange || this.handleChange.bind(this)}
					fullWidth={this.props.fullWidth}
					inputProps={{'data-notrequired': this.props['data-notrequired'] || null}}
					error={this.props.error}
					disabled={this.props.readOnly}
					readOnly={this.props.readOnly}>
					{ noOption }
					{this.props.options.map(option => (
						<option
							key={`${fieldName}_${option.value}`}
							value={option.value}>
							{option.title}
						</option>
					))}
				</Select>
			</div>
		);
	}
}

Dropdown.propTypes = {
	name: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired
}

export default Dropdown;
